module.exports = __webpack_public_path__ + "img/404.49c3c838.gif";